module.exports = __webpack_public_path__ + "media/images/footer_logo-25c47df9409cac920f22224bcad599f1.png";